import { render } from "./SetTicketPriority.vue?vue&type=template&id=6b5789f2&scoped=true"
import script from "./SetTicketPriority.vue?vue&type=script&lang=js"
export * from "./SetTicketPriority.vue?vue&type=script&lang=js"

import "./SetTicketPriority.vue?vue&type=style&index=0&id=6b5789f2&scoped=true&lang=css"

import exportComponent from "/var/www/html/genesis-git/vue-genesis/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b5789f2"]])

export default __exports__